/* eslint-disable no-unused-vars */
import { useAppSelector } from 'store/hooks';
import { selectCardData, selectCategories } from 'store/page/pageSlice';
import { useMatch, useParams, useSearchParams } from 'react-router-dom';
import find from 'lodash-es/find';
import { CategoryId } from 'store/types';

export const hrefMap: { [x: string]: CategoryId } = {
  photos: 'Фотографии',
  illustrations: 'Иллюстрации',
  vectors: 'Векторная графика',
};

export const isDefaultSection = (name: string) => {
  return name === 'illustrations' || name === 'photos' || name === 'vectors';
};

export const mapCategory = (category: string) => {
  return hrefMap[category];
};

export const useCurrentCategory = () => {
  const routeParams = useParams();
  const pageName = useMatch('/:name/*')?.params.name || 'photos';
  const categories = useAppSelector(selectCategories);
  const searchCategory = useSearchParams()[0].get('category') as CategoryId;

  const card = useAppSelector(selectCardData);

  let currentCategory: CategoryId = 'Фотографии';

  // Текущая категория определяется по основному разделу либо по категории в параметрах поиска
  if (pageName && isDefaultSection(pageName)) {
    currentCategory = mapCategory(pageName);
  } else if (searchCategory) {
    currentCategory = searchCategory;
  }

  // Если на странице карточки и карточка уже загрузилась и id в параметрах совпадает с id карточки
  if (routeParams.cardId && card && routeParams.cardId === card?._id) {
    currentCategory = card.category;
  }

  const resultCategory =
    find(categories, (c) => c.id === currentCategory) ||
    categories['Фотографии'];

  return resultCategory;
};
